import React from "react";
import { useIsMobile } from "../hooks/useIsMobile";
import { useCardVisibility } from "../hooks/useCardVisibility";
import { useAuth } from "../hooks/useAuth";
import { useInactivityWarning } from "../hooks/useInactivityWarning";
import ChatCard from "./cards/ChatCard";
import BlogCard from "./cards/BlogCard";
import GlobalHeader from "./GlobalHeader";
import GlobalFooter from "./GlobalFooter";
import BackgroundLogo from "./BackgroundLogo";
import { InactivityWarningModal } from "./InactivityWarningModal";
import { toast } from "sonner";

const CarlineLayout: React.FC = () => {
  const isMobile = useIsMobile();
  const { visibleCards } = useCardVisibility(isMobile);
  const { user, profile, signOut, refreshSession } = useAuth();

  // Inactivity warning system
  const { showWarning, timeRemaining, handleStillHere, handleLogout } = useInactivityWarning(
    !!user,
    signOut,
    refreshSession,
  );

  // Phase 1: Simplified handlers with resist bounce + toast
  const handleChatClick = () => {
    toast.info("Chat card coming soon! Follow the blog for updates.", {
      duration: 3000,
    });
  };

  const handleBlogDismiss = () => {
    toast.info("Blog is the only active card right now. Stay tuned!", {
      duration: 3000,
    });
  };

  return (
    <>

      <BackgroundLogo />
      
      <GlobalHeader
        user={user}
        profile={profile}
        onLogout={() => {
          console.log("onLogout called from CarlineLayout");
          signOut();
        }}
        shouldRetract={true}
      />

      <GlobalFooter shouldRetract={true} />
      
      <div className="min-h-screen bg-background font-sans overflow-y-auto overflow-x-hidden">
        {/* Chat Card - Locked to docked state */}
        <div data-card="chat">
          <ChatCard
            cardState="docked"
            isMobile={isMobile}
            onDockClick={handleChatClick}
          />
        </div>

        {/* Blog Card - Locked to fullscreen state */}
        <div data-card="blog">
          <BlogCard
            cardState="fullscreen"
            isMobile={isMobile}
            onHideCard={handleBlogDismiss}
          />
        </div>
      </div>

      <InactivityWarningModal
        open={showWarning}
        timeRemaining={timeRemaining}
        onStillHere={handleStillHere}
        onLogout={handleLogout}
      />
    </>
  );
};

export default CarlineLayout;
